module.exports = __webpack_public_path__ + "i18n/ja.cee9e4c587332069007e0753958b3ff4.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 850
// module chunks = 60